import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    comments: [],
    commenters: [],
    loading: false,
};
export var talentCommentState = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
